export default "__VITE_ASSET__SZOdIQKt__"